












































import Vue from "vue";
import moment from "moment";
import Web3 from "web3";
import { AbiItem } from "web3-utils";
import pinkSalePresaleContractABI from "../../assets/PinkSalePresaleContractABI.json";
import bep20ContractABI from "../../assets/BEP20ContractABI.json";

export default Vue.extend({
  name: "PresaleInfo",

  data: () => ({
    loading: false as boolean,
    presaleContractAddress: "" as string,
    tokenAddress: " " as string,
    tokenAddressLink: "" as string,
    tokenName: " " as string,
    ownerAddress: " " as string,
    ownerAddressLink: "" as string,
    startTime: " " as string,
    minContribution: " " as string,
    maxContribution: " " as string,
    error: "" as string,
  }),
  methods: {
    initialize(): void {
      this.error = "";
      this.tokenAddress = " ";
      this.tokenAddressLink = "";
      this.tokenName = " ";
      this.ownerAddress = " ";
      this.ownerAddressLink = "";
      this.startTime = " ";
      this.minContribution = " ";
      this.maxContribution = " ";
    },
    async click(): Promise<void> {
      this.initialize();

      let target = "";
      try {
        target = Web3.utils.toChecksumAddress(this.presaleContractAddress);
      } catch {
        this.error = "PresaleContract is invalid.";
        return;
      }
      const web3 = new Web3("https://bsc-dataseed1.defibit.io:443");
      const abi = pinkSalePresaleContractABI as any as AbiItem;
      const contract = new web3.eth.Contract(abi, target);

      try {
        this.loading = true;
        const results = await Promise.all<string, string, number, number, number>([
          contract.methods.token().call(),
          contract.methods.owner().call(),
          contract.methods.startTime().call(),
          contract.methods.minContribution().call(),
          contract.methods.maxContribution().call(),
        ]);

        this.tokenAddress = Web3.utils.toChecksumAddress(results[0]);
        this.tokenAddressLink = `https://bscscan.com/address/${this.tokenAddress}`;
        this.ownerAddress = Web3.utils.toChecksumAddress(results[1]);
        this.ownerAddressLink = `https://bscscan.com/address/${this.ownerAddress}`;
        this.startTime = moment.unix(results[2]).format("YYYY/MM/DD HH:mm:ss");
        this.minContribution = Web3.utils.fromWei(results[3].toString(), "ether");
        this.maxContribution = Web3.utils.fromWei(results[4].toString(), "ether");

        const tokenContractAbi = bep20ContractABI as any as AbiItem;
        const tokenContract = new web3.eth.Contract(tokenContractAbi, Web3.utils.toChecksumAddress(this.tokenAddress));
        this.tokenName = await tokenContract.methods.name().call();
      } catch (error: any) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
});
